import React from 'react';
import FormROValue from "../../../../library/form/components/FormROValue1"
import FormWrapper from "../../../../library/form/components/FormWrapper"
import FormButton from "../../../../library/form/components/FormActionButton2"

const ItemPriceRow = (props) => {
    const { formObject, rowKey } = props;
    return (
        <li className="list-row uiSearchRow">
            <ul>
                <li className="uiColumnCenter uiColumn150">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "priceDate" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "priceType" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "priceValue" }} />
                </li>
                <FormWrapper customWrapper="li" wrapperClass="uiColumnCenter uiColumn70" formObject={formObject} rowKey={rowKey} action={{ paramName: "priceValue2" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "priceValue2" }} />
                </FormWrapper>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "priceUnit" }} />
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "priceCurrency" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "priceFor" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "comments" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "additionalInfo" }} />
                </li>
                <li className="uiColumnCenter uiColumn70 uiActionBlock">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="" ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="clear"
                        onlyIcon={true}
                        tooltip="Delete"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "del",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        </li>
    )
}

export default ItemPriceRow